import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Warranty from "../pages/Warranty";
import Navbar from "./Navbar";

const AppRouter = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

const AppRoutes = () => {
  const location = useLocation();

  const shouldShowNavbar = () => {
    // You can make this always false if no Navbar is needed at all
    return false;
  };

  return (
    <>
      {shouldShowNavbar() && <Navbar />}
      <Routes>
        {/* Match all routes and render Warranty */}
        <Route path="*" element={<Warranty />} />
      </Routes>
    </>
  );
};

export default AppRouter;
